module.exports = __webpack_public_path__ + "media/images/favicon/secondary/ms-icon-150x150-2bb4151c117b29579887f7eeb4ffbe9e.png";